import { prefix } from '../../utils/prefix';

const Url = {
  getInfo: `${prefix}/info/bankInfo/get`,
  upload: `${prefix}/attachment/upload`,
  getNationality: `${prefix}/dataset/nationality`,
  getProvince: `${prefix}/dataset/province`,
  getCity: `${prefix}/dataset/city`,
  getBank: `${prefix}/dataset/bank`,
  getBranch: `${prefix}/dataset/bankBranch`,
  save: `${prefix}/info/bankInfo/save`,
};

export default Url;
